import {useAuthStore} from '~/stores/auth'

export default defineNuxtRouteMiddleware((to, from) => {
  const {$sentrySetUser} = useNuxtApp()
  const localeRoute = useLocaleRoute()
  const authStore = useAuthStore()
  if (authStore.isLogin) {
    $sentrySetUser({id: authStore.userInfo.id, username: authStore.userInfo.name, email: authStore.userInfo.email})
    return navigateTo(localeRoute('/'))
  }
})
